/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Occupancy mode of a dictionary type (Tryb zajętości). In requests optional; when omitted the stored value is left unchanged (EXCLUSIVE for a type configured for the first time). Switching to SHARED is never rejected. Switching back to EXCLUSIVE is rejected with BOOKING_MODE_MIGRATION_CONFLICT when the confirmed reservations of the type collide, also when `bookingMode` stays the same. A booking mode change of a SHARED type checks no conflicts.
 */

export const OccupancyModeDto = {
    Exclusive: 'EXCLUSIVE',
    Shared: 'SHARED',
} as const;

export type OccupancyModeDto = typeof OccupancyModeDto[keyof typeof OccupancyModeDto];



